import _ from "lodash";
import { toast } from 'react-toastify'

import API from "../../api";
import { queryClient } from "../../react-query"
import { useConectaPro } from "../../../store/service-activation/useConectaPro";
import { formatResponses } from '../../formatResponses/conecta-pro';
import {formatTemplateData} from "../../formatTemplateData/conecta-pro";

export class ConectaProModel {
  conectaProAction = useConectaPro.getState().actions

  constructor(props) {
    this.securityCodeModel = props.models.securityCode
  }

  async putSecurityCode(users) {
    const securityCodes = await this.securityCodeModel.fetchCodes(users.filter(u => u.ativo).map(u => u.celular), 'conecta-pro')
    return formatResponses.formatUsersWithSecurityCode(users, securityCodes)
  }

  async fetchUsers() {
    try {
      const result = await queryClient.ensureQueryData({
        queryKey: ['conecta-pro', 'users'],
        queryFn: async () => await API.get("conecta-pro/users")
      })

      const formatedUsers = await this.putSecurityCode(result.data)
      this.conectaProAction.setUsers(formatedUsers)

      return formatedUsers
    } catch (error) {
      console.error(error)
      toast.error('Não foi possível carregar os Usuários do Conecta Pro', { theme: 'colored' })
      return false
    }
  }
  async refreshSecurityCode(userId) {
    try {
      const user = useConectaPro.getState().data.users[userId]
      const result = await this.securityCodeModel.generateCode(user.cellphone, 'conecta-pro')

      return result
    } catch (error) {
      console.error(error)
      toast.error('Não foi possível cadastrar um novo Usuário', { theme: 'colored' })
      return false
    }
  }
  async createNewUser(data) {
    try {
      const result = await API.post(`conecta-pro/user`, formatTemplateData.formatUser(data))

      queryClient.setQueryData(['conecta-pro', 'users'], (oldData) => {
        if (!oldData?.data) return { data: [result.data] }
        return {
          ...oldData,
          data: result.data,
        }
      })

      const formatedUsers = await this.putSecurityCode(result.data)
      this.conectaProAction.setUsers(formatedUsers)

      return formatedUsers
    } catch (error) {
      console.error(error)
      toast.error('Não foi possível cadastrar um novo Usuário', { theme: 'colored' })
      return false
    }
  }
  async updateUser(userId, data) {
    try {
      const userData = useConectaPro.getState().data.users[userId]

      const result = await API.put(`conecta-pro/user/${userId}`, formatTemplateData.formatUser({...userData, ...data}))

      queryClient.setQueryData(['conecta-pro', 'users'], (oldData) => {
        if (!oldData?.data) return { data: [result.data] }
        return {
          ...oldData,
          data: result.data,
        }
      })

      const formatedUsers = await this.putSecurityCode(result.data)
      this.conectaProAction.setUsers(formatedUsers)

      return formatedUsers
    } catch (error) {
      console.error(error)
      toast.error('Não foi possível atualizar o Usuário', { theme: 'colored' })
      return false
    }
  }
  async deleteUser(userId) {
    try {
      const result = await API.delete(`conecta-pro/user/${userId}`)
      queryClient.setQueryData(['conecta-pro', 'users'], (oldData) => {
        if (!oldData?.data) return { data: [result.data] }
        return {
          ...oldData,
          data: result.data,
        }
      })

      const formatedUsers = await this.putSecurityCode(result.data)
      this.conectaProAction.setUsers(formatedUsers)

      return formatedUsers
    } catch (error) {
      console.error(error)
      toast.error('Não foi possível remover o Usuário', { theme: 'colored' })
      return false
    }
  }
}
